import {
  Button,
  ButtonProps,
  Chip,
  ChipProps,
  CircularProgress,
  CircularProgressProps,
  styled,
} from "@mui/material";

export const CustomChip = styled(Chip)<ChipProps>(({ theme }) => ({
  borderColor: "#E70070",
  color: "#E70070",
}));

export const PrimaryButton = styled(Button)<ButtonProps>(({ theme }) => ({
  boxShadow: "none",
  fontSize: 14,
  lineHeight: "36px",
  padding: "8px 12px",
  borderRadius: "21px",
  backgroundColor: "#E70070",
  border: "1px solid #E70070",
  color: "#FFFFFF",
  fontFamily: "EnergyBold, sans-serif",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "36px",
  textTransform: "none",

  "&:hover": {
    backgroundColor: "#9F004F",
    borderColor: "#9F004F",
    color: "#FFFFFF",
  },

  "&:focus": {
    outline: "none",
  },

  "& .btn-primary__icon": {
    marginLeft: "4px",
  },
}));

export const BorderSecondary = styled(Button)<ButtonProps>(() => ({
  borderRadius: "21px",
  backgroundColor: "transparent",
  border: "2px solid #E70070",
  padding: "8px 12px",
  color: "#E70070",
  fontSize: 14,
  lineHeight: "38px",
  fontFamily: "EnergyBold, sans-serif",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "36px",
  cursor: "pointer",
  textTransform: "none",

  "&:hover": {
    color: "#9F004F",
    borderColor: "#9F004F",
  },

  "&:focus": {
    outline: "none",
  },

  "& .btn-border__icon": {
    marginLeft: "4px",
  },
}));

export const CircularProgressCustom = styled(CircularProgress)<CircularProgressProps>(
  ({ theme }) => ({
    color: "#E70070",
  })
);
